import React from 'react';
import { FileEntity, FileWithSas } from '../types/file';

export interface FileContextProps {
  fileCache: Map<string, FileWithSas>;
  setFileCache: (cache: Map<string, FileWithSas>) => void;

  files: Map<string, FileEntity>;
  setFiles: (files: Map<string, FileEntity>) => void;
  filesLoading: boolean;
}

const defaultContext: FileContextProps = {
  fileCache: new Map(),
  setFileCache: () => null,
  files: new Map(),
  setFiles: () => {},
  filesLoading: false,
};

export const FileContext = React.createContext<FileContextProps>(defaultContext);
